/**
 * Closed vocabularies for catalog entries — mirrors the backend
 * CatalogProduct::AUDIENCES / TRADES constants. Keep in sync.
 */

export const CATALOG_AUDIENCES = [
  "Owners",
  "GMs",
  "Managers",
  "Sales Advisors",
  "Technicians",
  "CSRs",
  "Marketing Teams",
] as const;

export const CATALOG_TRADES = [
  "HVAC",
  "Plumbing",
  "Electrical",
  "Roofing",
  "All Trades",
] as const;
